import type {
  CompanyLink,
  CompanySec,
  Defi,
  Eco,
  Learn,
  LearnSec,
  Products,
  Section,
} from './types'

export const products_fr: Products[] = [
  {
    tTitle: 'products.buyAndSell',
    tDesc: 'products.appDescription',
    href: '/fr/app',
  },
  {
    tTitle: 'products.metalCards',
    tDesc: 'products.metalCardsDescription',
    href: '/fr/cards',
  },
  {
    tTitle: 'products.pay',
    tDesc: 'products.payDescription',
    href: '/fr/pay',
  },
  {
    tTitle: 'products.earn',
    tDesc: 'products.earnDescription',
    href: '/fr/earn',
  },
]

export const defi_fr: Defi[] = [
  {
    tTitle: 'products.defiWallet',
    tDesc: 'products.defiWalletDescription',
    href: '/fr/defi-wallet',
  },
  {
    tTitle: 'products.browserExt',
    tDesc: 'products.browserExtDescription',
    href: '/fr/defi-wallet#wallet_extension',
  },
  {
    tTitle: 'products.desktopWallet',
    tDesc: 'products.desktopWalletDescription',
    href: '/fr/defi-wallet#defi_wallet_desktop',
  },
]

export const eco_fr: Eco[] = [
  {
    tTitle: 'products.payMerchant',
    tDesc: 'products.payMerchantDescription',
    href: '/fr/pay-merchant',
  },
]

export const products_desktop_fr: Section[] = [
  {
    tTitle: 'products.sectionTitle_getStarted',
    items: [
      {
        tTitle: 'products.categoryTitle_buyAndSell',
        items: [
          {
            tTitle: 'products.app',
            tDesc: 'products.appDescription',
            href: '/fr/app',
          },
          {
            tTitle: 'products.nft',
            tDesc: 'products.nftDescription',
            href: 'https://crypto.com/nft',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_spend',
        items: [
          {
            tTitle: 'products.metalCards',
            tDesc: 'products.metalCardsDescription',
            href: '/fr/cards',
          },
          {
            tTitle: 'products.pay',
            tDesc: 'products.payDescription',
            href: '/fr/pay',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_grow',
        items: [
          {
            tTitle: 'products.earn',
            tDesc: 'products.earnDescription',
            href: '/fr/earn',
          },
        ],
      },
    ],
  },
  {
    tTitle: 'products.sectionTitle_advancedTrading',
    items: [
      {
        tTitle: 'products.categoryTitle_defi',
        items: [
          {
            tTitle: 'products.defiWallet',
            tDesc: 'products.defiWalletDescription',
            href: '/fr/defi-wallet',
          },
          {
            tTitle: 'products.browserExt',
            tDesc: 'products.browserExtDescription',
            href: '/defi-wallet#wallet_extension',
          },
          {
            tTitle: 'products.desktopWallet',
            tDesc: 'products.desktopWalletDescription',
            href: '/defi-wallet#defi_wallet_desktop',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_ecosystem',
        items: [
          {
            tTitle: 'products.payMerchant',
            tDesc: 'products.payMerchantDescription',
            href: '/fr/pay-merchant',
          },
        ],
      },
      //TODO just found that this is a placeholder to align with design ... need to improve later
      {
        tTitle: '',
        items: [
          {
            tTitle: '',
            tDesc: '',
            href: '/', //NOTE add a relative path to avoid dev console warning of using GatsbyLink for external link
          },
        ],
      },
    ],
  },
]

export const learn_fr: Learn[] = [
  {
    tTitle: 'learn.trending',
    tDesc: 'learn.trendingDescription',
    href: `/trending`,
  },
  {
    tTitle: 'learn.marketUpdates',
    tDesc: 'learn.marketUpdatesDescription',
    href: `/market-updates`,
  },
  {
    tTitle: 'learn.productNews',
    tDesc: 'learn.productNewsDescription',
    href: `/product-news`,
  },
  {
    tTitle: 'learn.events',
    tDesc: 'learn.eventsDescription',
    href: `/events`,
  },
  {
    tTitle: 'learn.university',
    tDesc: 'learn.universityDescription',
    href: `/university`,
  },
  {
    tTitle: 'learn.reportsAndAnalysis',
    tDesc: 'learn.reportsAndAnalysisDescription',
    href: `/research`,
  },
  {
    tTitle: 'learn.nftStories',
    tDesc: 'learn.nftStoriesDescription',
    href: `/nft-stories`,
  },
]

export const company_fr: CompanyLink[] = [
  {
    tTitle: 'company.about',
    tDesc: 'company.aboutDescription',
    href: '/fr/about',
  },
  {
    tTitle: 'company.careers',
    tDesc: 'company.careersDescription',
    href: '/fr/careers',
  },
  {
    tTitle: 'company.news',
    tDesc: 'company.newsDescription',
    href: `https://crypto.com/company-news`,
  },
  {
    tTitle: 'company.support',
    tDesc: 'company.supportDescription',
    href: 'https://help.crypto.com/en',
  },
  {
    tTitle: 'company.security',
    tDesc: 'company.securityDescription',
    href: '/fr/security',
  },
  {
    tTitle: 'company.partners',
    tDesc: 'company.partnersDescription',
    href: '/fr/partners',
  },
]

export const learn_desktop_fr: LearnSec[] = [
  {
    tTitle: 'learn.categoryTitle_updates',
    items: [
      {
        tTitle: 'learn.trending',
        tDesc: 'learn.trendingDescription',
        href: `/trending`,
      },
      {
        tTitle: 'learn.events',
        tDesc: 'learn.eventsDescription',
        href: `/events`,
      },
      {
        tTitle: 'learn.productNews',
        tDesc: 'learn.productNewsDescription',
        href: `/product-news`,
      },
      {
        tTitle: 'learn.marketUpdates',
        tDesc: 'learn.marketUpdatesDescription',
        href: `/market-updates`,
      },
    ],
  },
  {
    tTitle: 'learn.categoryTitle_resources',
    items: [
      {
        tTitle: 'learn.university',
        tDesc: 'learn.universityDescription',
        href: `/university`,
      },
      {
        tTitle: 'learn.reportsAndAnalysis',
        tDesc: 'learn.reportsAndAnalysisDescription',
        href: `/research`,
      },
      {
        tTitle: 'learn.nftStories',
        tDesc: 'learn.nftStoriesDescription',
        href: '/nft-stories',
      },
    ],
  },
]

export const company_desktop_fr: CompanySec[] = [
  {
    tTitle: 'company.sectionTitle_aboutUs',
    items: [
      {
        tTitle: 'company.about',
        tDesc: 'company.aboutDescription',
        href: '/fr/about',
      },
      {
        tTitle: 'company.support',
        tDesc: 'company.supportDescription',
        href: 'https://help.crypto.com/en',
      },
      {
        tTitle: 'company.careers',
        tDesc: 'company.careersDescription',
        href: '/fr/careers',
      },
      {
        tTitle: 'company.security',
        tDesc: 'company.securityDescription',
        href: '/fr/security',
      },
      {
        tTitle: 'company.news',
        tDesc: 'company.newsDescription',
        href: `https://crypto.com/company-news`,
      },
      {
        tTitle: 'company.partners',
        tDesc: 'company.partnersDescription',
        href: '/fr/partners',
      },
    ],
  },
]
